import { JSX, useEffect, useRef } from 'react';

import styles from './Spinner.module.scss';

interface SpinnerProps {
  onLoadMore?(): void;
}

export const Spinner = ({ onLoadMore }: SpinnerProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current || !onLoadMore) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const item = entries[0];

        if (item && item.intersectionRatio > 0) {
          onLoadMore();
        }
      },
      { rootMargin: `${window.innerHeight}px` },
    );

    ref.current && observer.observe(ref.current);

    return () => observer.disconnect();
  }, [onLoadMore]);

  return (
    <div ref={ref} className={styles.spinerContainer}>
      <div className={styles.spinner} />
    </div>
  );
};
